<template>
  <vue-drr
    :parent="true"
    :rotatable="true"
    :w="w"
    :h="h"
    :x="x"
    :y="y"
    :angle="r"
    class="widget-container"
    ref="widget"
    @dragstop="dragStop"
    @rotatestop="rotateStop"
    @resizestop="resizeStop"
    :style="{
      zIndex: zIndex
    }"
  >
    <div
      class="widget animated bounceIn"
      :id="`widget${id}`"
      @click="setActiveWidget"
      :style="{
        justifyContent: justifyContent,
        alignItems: alignItems
      }"
    >
      <img
        src="@/assets/images/placeholder_magio_200x200.jpg"
        class="w-100"
      />
    </div>
  </vue-drr>
</template>

<script>
import VueDrr from 'vue-drr';
import WidgetMixin from './WidgetMixin';
import { mapWidgets } from './WidgetUtils';

export default {
  components: {
    'vue-drr': VueDrr,
  },
  mixins: [WidgetMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: '',
          key: 'name',
        },
        {
          path: '',
          key: 'icon',
        },
        {
          path: '',
          key: 'component',
        },
        {
          path: 'style',
          key: 'justifyContent',
        },
        {
          path: 'style',
          key: 'alignItems',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'directorFlags',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
        {
          path: 'style',
          key: 'r',
        },
      ],
    ),
  },
};
</script>

<style scoped>

</style>
